<template>
  <div class="log-page">
    <van-nav-bar left-arrow class="crystal-nav" @click-left="gotohome">
      <template #left>
        <van-icon name="arrow-left" size="20px" color="#475569" />
      </template>
      <template #title>
        <span class="nav-title">自动换水器 · 运行日志</span>
      </template>
    </van-nav-bar>

    <van-tabs v-model="activeTab" color="#10b981" title-active-color="#059669" class="crystal-tabs">
      <van-tab title="补水记录">
        <div class="tab-content">
          <div v-if="replenishLogs.length === 0" class="empty-state">
            <span class="iconfont icon-bushuitubiao empty-icon"></span>
            <div class="empty-text">暂无补水记录</div>
          </div>
          <!-- 新版卡片: 任务类型+结果标签 / 补水用时 / 完成时间(不含秒) -->
          <div v-for="(log, index) in replenishLogs" :key="index" class="log-card">
            <div class="log-head">
              <span class="log-type">{{ replenishTypeText(log) }}</span>
              <span class="log-tag" :class="resultTag(log.et).cls">{{ resultTag(log.et).text }}</span>
            </div>
            <div class="log-line log-line--strong" v-if="log.tm != null">补水{{ formatSec(log.tm) }}</div>
            <div class="log-line log-line--gray">{{ formatLogTime(log.create_time) }}</div>
          </div>
        </div>
      </van-tab>

      <van-tab title="换水记录">
        <div class="tab-content">
          <div v-if="wcLogs.length === 0" class="empty-state">
            <span class="iconfont icon-huanshui empty-icon"></span>
            <div class="empty-text">暂无换水记录</div>
          </div>
          <!-- 新版卡片四行: 类型+结果 / 方式+水量 / 排水补水用时 / 完成时间 -->
          <div v-for="(log, index) in wcLogs" :key="index" class="log-card">
            <div class="log-head">
              <span class="log-type">{{ wcTypeText(log) }}</span>
              <span class="log-tag" :class="resultTag(log.et).cls">{{ resultTag(log.et).text }}</span>
            </div>
            <div class="log-line log-line--strong">{{ wcModeText(log) }}</div>
            <div class="log-line log-line--gray">{{ wcDurationText(log) }}</div>
            <div class="log-line log-line--gray">{{ formatLogTime(log.create_time) }}</div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  name: "KD6Log",
  data() {
    return {
      activeTab: 1,
      did: this.$route.query.did,
      udname: this.$route.query.udname || "KD-6设备",
      replenishLogs: [],
      wcLogs: [],
    };
  },
  mounted() {
    this.gethistory();
  },
  methods: {
    gethistory() {
      const qs = require("qs");
      this.$axios
        .post("/api/dev/history", qs.stringify({
          did: this.did,
          dtype: "KD-6",
          history: "log",
          tnum: 30,
          tunit: "day",
        }))
        .then((response) => {
          if (response.data.error_code === 0) {
            /* log_buf 可能缺失（无日志/表不存在），防御处理避免页面报错;
               按启动时间倒序, 最新在最上 (文档修改项28) */
            var logBuf = response.data.data.log_buf || {};
            this.replenishLogs = this.parseLogs(logBuf.replenish)
              .sort((a, b) => (Number(b.st) || 0) - (Number(a.st) || 0));
            this.wcLogs = this.parseLogs(logBuf.water_change)
              .sort((a, b) => (Number(b.st) || 0) - (Number(a.st) || 0));
          } else if (response.data.error_code === 301) {
            this.$router.push({ path: "/login", name: "login" });
          } else {
            this.$toast.fail("获取日志失败(" + response.data.error_code + ")");
          }
        })
        .catch((error) => {
          this.$toast.fail("获取日志失败");
        });
    },
    parseLogs(rawLogs) {
      if (!rawLogs || !rawLogs.length) return [];
      return rawLogs.map(function (entry) {
        var parsed = JSON.parse(entry[0]);
        parsed.create_time = entry[1];
        return parsed;
      });
    },
    /* 任务类型 (文档修改项22): 新固件 sc=1预约 2间隔 3手动; step5=单独排水;
       旧固件无 sc 时回退 st(1自动/2手动) */
    wcTypeText(log) {
      if (Number(log.step) === 5) return "单独排水";
      var sc = log.sc != null ? Number(log.sc) : null;
      if (sc === 1) return "预约换水";
      if (sc === 2) return "间隔换水";
      if (sc === 3) return "手动换水";
      var map = { 1: "自动换水", 2: "手动换水" };
      return map[Number(log.st)] || "换水";
    },
    replenishTypeText(log) {
      var map = { 1: "自动补水", 2: "单独补水" };
      return map[Number(log.st)] || "补水";
    },
    /* 第二行: 换水方式和换水量 (文档修改项23/24) */
    wcModeText(log) {
      var al = Number(log.al) || 0;
      var actual = (al / 100).toFixed(2) + "L";
      if (Number(log.step) === 5) {
        return Number(log.sl) > 0
          ? `定量排水 · 目标${log.sl}L / 实际${actual}`
          : `已排 ${actual}`;
      }
      if (Number(log.sl) > 0) {
        return `定量换水 · 目标${log.sl}L / 实际${actual}`;
      }
      return "区间换水 · 低水位→高水位";
    },
    /* 第三行: 排水/补水实际用时 (swt=排水 fwt=补水, 文档修改项25) */
    wcDurationText(log) {
      var parts = [];
      if (Number(log.swt) > 0) parts.push(`排水${this.formatSec(Number(log.swt))}`);
      if (Number(log.fwt) > 0) parts.push(`补水${this.formatSec(Number(log.fwt))}`);
      return parts.length ? parts.join(" · ") : "--";
    },
    /* 执行结果标签 (文档修改项27): 完成=绿 已停止=橙 故障=红 */
    resultTag(et) {
      var e = Number(et);
      if (e === 0) return { text: "已完成", cls: "log-tag--ok" };
      if (e === -3 || e === -6) return { text: "已停止", cls: "log-tag--stop" };
      return { text: "未完成", cls: "log-tag--fail" };
    },
    /* 完成时间不含秒 (文档修改项26): 截取 YYYY-MM-DD HH:MM */
    formatLogTime(ts) {
      if (!ts) return "";
      var m = String(ts).match(/(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2})/);
      return m ? `${m[1]} ${m[2]}` : String(ts);
    },
    formatSec(sec) {
      if (sec == null || sec <= 0) return "0秒";
      if (sec < 60) return `${sec}秒`;
      if (sec < 3600) return `${Math.floor(sec / 60)}分${sec % 60}秒`;
      var h = Math.floor(sec / 3600);
      var m = Math.floor((sec % 3600) / 60);
      return `${h}时${m}分`;
    },
    gotohome() {
      this.$router.go(-1);
    },
  },
};
</script>

<style>
.crystal-nav {
  background: #ffffff !important;
  border-bottom: 1px solid #f1f5f9;
}

.nav-title {
  font-size: 15px;
  font-weight: 600;
  color: #1e293b;
  max-width: 70vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.crystal-tabs .van-tabs__wrap {
  background: #ffffff;
}

.crystal-tabs .van-tab {
  font-weight: 500;
}

.crystal-tabs .van-tabs__line {
  background-color: #10b981;
}
</style>

<style scoped>
.log-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #f8fafc;
}

.tab-content {
  padding: 12px;
  height: calc(100vh - 92px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 0;
  color: #94a3b8;
}

.empty-icon {
  font-size: 48px;
  opacity: 0.4;
  margin-bottom: 12px;
}

.empty-text {
  font-size: 14px;
  font-weight: 500;
}

.log-card {
  background: #ffffff;
  border-radius: 14px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
  padding: 14px 16px;
  margin-bottom: 10px;
}

.log-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.log-type {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
}

/* 执行结果: 圆角浅色标签 (文档修改项27/29) */
.log-tag {
  font-size: 11px;
  font-weight: 600;
  padding: 3px 10px;
  border-radius: 999px;
}

.log-tag--ok {
  color: #059669;
  background: #d1fae5;
}

.log-tag--stop {
  color: #d97706;
  background: #fef3c7;
}

.log-tag--fail {
  color: #dc2626;
  background: #fee2e2;
}

.log-line {
  font-size: 13px;
  line-height: 1.9;
}

/* 换水方式和换水量: 深色 (文档修改项29) */
.log-line--strong {
  color: #334155;
  font-weight: 500;
}

/* 用时和时间: 灰色 (文档修改项29) */
.log-line--gray {
  color: #94a3b8;
}
</style>
